import * as React from 'react';

import Retracked from 'js/app/retracked';

import useUrlData from 'bundles/shared-articles/hooks/useArticleUrlData';
import { SEO_CONTENT_PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import useSeoContentContentPageQuery from 'bundles/unified-seo-content-common/hooks/useSeoContentContentPageQuery';
import useHubPageLink from 'bundles/unified-seo-content-common/hooks/useSeoContentHubPageLink';
import ResourceContentPage from 'bundles/unified-seo-content-common/pages/resource/ResourceContentPage';
import PageInfoProvider from 'bundles/unified-seo-content-common/providers/PageInfoProvider';

const ResourceContentPageRoot = () => {
  const pageType = SEO_CONTENT_PAGE_TYPE.resources;

  const { slug, isPreview, subfolderLocaleCode } = useUrlData();
  const { pageData } = useSeoContentContentPageQuery({ slug, pageType, preview: isPreview });
  const hubPageLink = useHubPageLink({ pageType, skipQuery: true });

  return (
    <PageInfoProvider pageType={pageType}>
      <ResourceContentPage
        pageData={pageData}
        slug={slug}
        subfolderLocaleCode={subfolderLocaleCode}
        hubPageLink={hubPageLink}
      />
    </PageInfoProvider>
  );
};

export default Retracked.createTrackedContainer(() => ({
  namespace: {
    app: 'resources',
    page: 'resource_content_page',
  },
}))(ResourceContentPageRoot);
